import { render } from "./FarmEducation.vue?vue&type=template&id=2fb5ef68&scoped=true"
import script from "./FarmEducation.vue?vue&type=script&lang=js"
export * from "./FarmEducation.vue?vue&type=script&lang=js"

import "./FarmEducation.vue?vue&type=style&index=0&id=2fb5ef68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb5ef68"]])

export default __exports__